import React, { FC } from 'react';
import LinkIcon from '@v2/context/ProductionBatch/linkIcon';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { scale } from '@components/frame';
import { useManageLinkIconWithInfo } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/hooks/useManageLinkIconWithInfo';
import { ContainerStyle } from '@interfaces/base';
import { TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';

interface LinkIconWithJobNumbersProps extends ContainerStyle {
  C: ColorFunction;
}

const LinkIconWithInfo: FC<LinkIconWithJobNumbersProps> = ({ C, containerStyle }) => {
  const { linkIconSize } = TOP_BLOCK_CONFIG;

  const { linkText, takeIntoAccountOnlyNcFileStatus, shouldDisplayLinkIcon, withERPValue, linkStatus, ncFileStatus } = useManageLinkIconWithInfo();

  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center', gap: scale(9) }, containerStyle]}>
      {shouldDisplayLinkIcon ? (
        <LinkIcon
          takeIntoAccountOnlyNcFileStatus={takeIntoAccountOnlyNcFileStatus}
          isWithERP={withERPValue}
          linkStatus={linkStatus}
          ncFileStatus={ncFileStatus}
          width={scale(linkIconSize)}
          height={scale(linkIconSize)}
        />
      ) : (
        <View style={{ width: scale(linkIconSize), height: scale(linkIconSize) }} />
      )}
      <Text numberOfLines={1} style={[font.Body, { color: C('Label/Light/Primary'), flex: 1 }]}>
        {linkText}
      </Text>
    </View>
  );
};

export default ColorWrapper(LinkIconWithInfo);
